import { render } from "./Loading.vue?vue&type=template&id=3df8aa82&scoped=true&ts=true"
import script from "./Loading.vue?vue&type=script&setup=true&lang=ts"
export * from "./Loading.vue?vue&type=script&setup=true&lang=ts"

import "./Loading.vue?vue&type=style&index=0&id=3df8aa82&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src444904090/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df8aa82"],['__file',"src/components/abrs/Loading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3df8aa82"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3df8aa82', __exports__)) {
    console.log('reload')
    api.reload('3df8aa82', __exports__)
  }
  
  module.hot.accept("./Loading.vue?vue&type=template&id=3df8aa82&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('3df8aa82', render)
  })

}


export default __exports__